import {
  checkFormValidation,
  setColumnIsValid,
} from "common/form/functions/validation";
import type { FormValidation } from "common/form/types";
import { hasPermissionToRead } from "common/functions/roles";
import { Context } from "common/types/context";
import type { Filter, FilterDefault } from "common/types/filters";

export const validateFilterFields = (
  filter: Filter,
  context: Context,
  formValidation: FormValidation,
) => {
  const { name, shared, sites, roleIds } = filter ?? {};
  const { role, userTypes } = context;
  const canAccessRoles = hasPermissionToRead(userTypes, role, "Roles");

  const nameValidation = setColumnIsValid(formValidation, "name", !!name);
  const sitesValidation = setColumnIsValid(
    nameValidation,
    "sites",
    !!shared === !!sites?.length,
  );

  return setColumnIsValid(
    sitesValidation,
    "roleIds",
    (!shared && !roleIds?.length) ||
      (shared && (!roleIds?.length || canAccessRoles)),
  );
};

const filterDefaultsBySites = (defaults: FilterDefault[], sites: string[]) =>
  defaults?.filter((def) => (sites || []).some((site) => site === def.site));

const filterDefaultsByRoles = (defaults: FilterDefault[], roleIds: number[]) =>
  defaults?.map((def) => ({
    ...def,
    roleIds: def.roleIds?.filter((roleId) => (roleIds || []).includes(roleId)),
  }));

export const getFilteredDefaults = (
  filter: Filter,
  newSites?: string[],
  newRoleIds?: number[],
) => {
  if (!filter) return undefined;

  const { defaults, sites, roleIds } = filter;
  const sitesToUse = newSites ?? sites ?? [];
  const roleIdsToUse = newRoleIds ?? roleIds ?? [];

  const filteredBySites = filterDefaultsBySites(defaults, sitesToUse);
  return roleIdsToUse.length === 0
    ? filteredBySites
    : filterDefaultsByRoles(filteredBySites, roleIdsToUse);
};

export const isFilterValid = (filter: Filter, formValidation: FormValidation) =>
  !!filter && !!filter.name && checkFormValidation(formValidation);
